import React, { useEffect, useState } from 'react';
import { supabase } from '../lib/supabaseClient';
import CompanyLogosSection from './CompanyLogosSection';

type ProductBrandLogo = {
  id: string;
  brand_name: string;
  logo_url: string;
  website_url: string | null;
};

const ProductBrandLogosSectionWrapper: React.FC = () => {
  const [logos, setLogos] = useState<ProductBrandLogo[]>([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    void fetchProductBrandLogos();
  }, []);

  const fetchProductBrandLogos = async () => {
    try {
      const { data, error } = await supabase
        .from('product_brand_logos')
        .select('id, brand_name, logo_url, website_url')
        .eq('is_active', true)
        .order('display_order', { ascending: true });
      if (error) throw error;
      setLogos(data ?? []);
    } catch (error) {
      console.error('Error fetching product brand logos:', error);
    } finally {
      setLoading(false);
    }
  };

  if (loading || logos.length === 0) return null;

  const mapped = logos.map((logo) => ({
    id: logo.id,
    company_name: logo.brand_name,
    logo_url: logo.logo_url,
    website_url: logo.website_url,
  }));

  return (
    <CompanyLogosSection
      logos={mapped}
      title="Varumärken vi använder"
      subtitle="Professionella märken som ligger bakom utrustningen i våra paket"
      className="mb-16 md:mb-20"
    />
  );
};

export default ProductBrandLogosSectionWrapper;
